module.exports = __webpack_public_path__ + "img/15.2ce505bd.png";